export default __webpack_public_path__ + "static/cfm-ai-features-aa2cd147dd69bc133a46b68c0b385fa9.mp4";